enum ReportStatus {
  RUNNING = 'Running',
  COMPLETE = 'Complete',
  // If the analyzed image is unacceptable, the status will be failed.
  FAILED = 'Failed',
  RETRIGGER = 'Retrigger',
}

export { ReportStatus };
